import { requestApi } from "../../apiService";
import { ApiEndpoints } from "../../apiEndpoints";

import {
  EncryptedMessage,
  GetCommentsWithSignal,
  GetMessagesWithSignal,
  GetMessageWithSignal,
  MessagesResponse,
} from "@/server/types/umbra/message";

export const umbra_getMessages = async ({
  chatId,
  after,
  before,
  pageSize,
  includeSystem,

  signal,
}: GetMessagesWithSignal): Promise<MessagesResponse> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages`,
      method: "GET",
      params: {
        after,
        before,
        pageSize,
        includeSystem,
      },
      signal,
    },
    { retry429: true },
  );
  return response.data;
};

export const umbra_getMessage = async ({
  chatId,
  messageId,
  signal,
}: GetMessageWithSignal): Promise<EncryptedMessage> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages/${messageId}`,
      method: "GET",
      signal,
    },
    { retry429: true },
  );
  return response.data;
};

export const umbra_getComments = async ({
  chatId,
  threadId,
  after,
  before,
  pageSize,
  signal,
}: GetCommentsWithSignal): Promise<MessagesResponse> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.UMBRA_MESSAGES}/${chatId}/messages`,
      method: "GET",
      params: { threadId, after, before, pageSize },
      signal,
    },
    { retry429: true },
  );
  return response.data;
};
